export enum SiteMode {
    PartnerApis = 'PartnerApis',
    TenantApis = 'TenantApis',
}
